import React from 'react'
import { Box, Link, Text, VStack, Heading } from '@chakra-ui/react'
import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { formatNewsDate } from '../utils/newsDate'



type CourseProps = {
    title: string;
    subTitle: string;
    image: any;
    id: string;
    publicationDate?: string;
    isEvidence?: boolean;
}


const News = ({title, subTitle, image, id, publicationDate, isEvidence}: CourseProps) => {
  const { t, i18n } = useTranslation()
  const formattedDate = formatNewsDate(publicationDate, i18n.language)
    
  return (
        <Link
            display="block"
            textDecoration="none"
            _hover={{ textDecoration: 'none' }}
            href={`news/${id}`}>
        <motion.div
            whileHover={{ scale: 1.025, y: -6 }}
            transition={{ duration: 0.25 }}
        >
            <Box
                {...(isEvidence && { maxW: '800px' })}
                width="100%"
                height={{ base: '390px', md: '470px' }}
                backgroundColor="gray.900"
                backgroundImage={image}
                backgroundSize={'cover'}
                backgroundPosition={'center'}
                backgroundRepeat={'no-repeat'}
                borderRadius={{ base: '22px', md: '28px' }}
                overflow="hidden"
                position={'relative'}
                boxShadow="0 12px 30px rgba(25, 25, 35, 0.12)"
                >
                    <Box
                        position={'absolute'}
                        bottom={0}
                        left={0}
                        w={'100%'}
                        h={'62%'}
                        bgGradient={'linear(to-t, rgba(0, 0, 0, 0.82), rgba(0, 0, 0, 0))'}
                        zIndex={1}
                    />
                    <VStack
                        position={'absolute'}
                        top={'5%'}
                        left={'5%'}
                        align={'flex-start'}
                        spacing={1}
                        zIndex={2}>
                      <Text
                        bg={'rgba(255,255,255,0.82)'}
                        borderRadius={'full'}
                        padding={'6px 12px'}
                        fontWeight={'bold'}
                        fontSize={'sm'}
                        color={'gray.900'}>
                        {t('news.new')}
                      </Text>
                      {formattedDate && <Text
                        color={'white'}
                        fontSize={'xs'}
                        fontWeight={'bold'}
                        textTransform={'uppercase'}
                        letterSpacing={'0.04em'}>
                        {formattedDate}
                      </Text>}
                    </VStack>
                    <VStack
                        position={'absolute'}
                        bottom={{ base: 5, md: 7 }}
                        left={0}
                        right={0}
                        padding={'0 5%'}
                        align="flex-start"
                        spacing={2}
                        zIndex={2}
                        >
                        
                        <Heading
                            color={'white'}
                            fontSize={{ base: 'xl', md: '2xl' }}
                            fontWeight={'bold'}
                            lineHeight="1.1"
                            textAlign="left"
                            >
                            {t(title)}
                        </Heading>
                        <Text
                            color={'white'}
                            fontSize={'sm'}
                            fontWeight={'light'}
                            opacity={0.9}
                            textAlign="left"
                            >
                            {subTitle ? t(subTitle) : null}
                        </Text>
                        </VStack>
            </Box>
        
        </motion.div>
        </Link>
  )
}

export default News
